export const DEFAULT_SOURCE_PORT_ID = 'defaultSourcePort';
export const DEFAULT_TARGET_PORT_ID = 'defaultTargetPort';

export function addDefaultPortId(type, edgePoint) {
  if (type !== 'source' && type !== 'target') {
    return edgePoint;
  }
  const defaultPortId =
    type === 'source' ? DEFAULT_SOURCE_PORT_ID : DEFAULT_TARGET_PORT_ID;
  const splitEdgePoint = edgePoint.split('.');
  const blockId = splitEdgePoint[0];
  const portId = splitEdgePoint[1] || defaultPortId;
  return `${blockId}.${portId}`;
}

export function removeDefaultPortId(type, edgePoint) {
  if (type !== 'source' && type !== 'target') {
    return edgePoint;
  }
  const defaultPortId =
    type === 'source' ? DEFAULT_SOURCE_PORT_ID : DEFAULT_TARGET_PORT_ID;
  const splitEdgePoint = edgePoint.split('.');
  const blockId = splitEdgePoint[0];
  const portId = splitEdgePoint[1] || '';
  if (portId === defaultPortId || !portId.length) {
    return blockId;
  }
  return `${blockId}.${portId}`;
}
